window.onscroll = scrollHeader

function scrollHeader() {
	let header = document.querySelector('header')
	let headerTop = header.querySelector('.header__top-part')
	let mobTop = header.querySelector('.header__mob-part')
	if (window.innerWidth > 1250) {
		if (window.scrollY < 50) {
			headerTop.removeAttribute('scroll')
		} else {
			headerTop.setAttribute('scroll', '')
		}
	} else {
		if (window.scrollY < 50) {
			headerTop.removeAttribute('scroll')
			mobTop.removeAttribute('scroll')
		} else {
			headerTop.setAttribute('scroll', '')
			mobTop.setAttribute('scroll', '')
		}
	}
}
